import { UserFilters } from '@dispatch/shared/types';
import { usePaginatedQuery } from '../api/usePaginatedQuery';
import { getUsers } from '@dispatch/shared/services';
import { isEmpty } from 'lodash';

export const useGetUsers = (filters?: UserFilters) => {
  return usePaginatedQuery(
    ['users', filters],
    async (token) => getUsers(filters, token),
    {
      enabled: !isEmpty(filters),
      staleTime: 60000,
    }
  );
};
